import { getGraphQLClientAsync } from 'lib/graphql-client-factory/manual-config';

export interface SiteRoot {
  id: string;
  name: string;
  path: string;
}

export async function getSiteRoot(
  site: string,
  language: string = 'en'
): Promise<SiteRoot | undefined> {
  const graphqlClient = await getGraphQLClientAsync();

  const siteRootResult = await graphqlClient.request<GetSiteRootType>(SITE_ROOT_QUERY, {
    site,
    routePath: '/',
    language,
  });

  return siteRootResult.layout?.item?.parent;
}

const SITE_ROOT_QUERY = `
  query GetSiteRoot($site: String!, $routePath: String!, $language: String!) {
    layout(site: $site, routePath: $routePath, language: $language) {
      item {
        parent {
          id
          name
          path
        }
      }
    }
  }
`;

type GetSiteRootType = {
  layout?: {
    item?: {
      parent?: {
        id: string;
        name: string;
        path: string;
      };
    };
  };
};
